import {
  Controller,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import MUITextField from "@mui/material/TextField";
import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { InputBaseComponentProps } from "@mui/material";
import { ChangeEvent, CSSProperties, FocusEvent, ReactNode } from "react";

interface IProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  fieldName: string;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  disabled?: boolean;
  type?: string;
  size?: "small" | "medium" | undefined;
  fullWidth?: boolean;
  adornmentString?: string | undefined;
  className?: string;
  placeholder?: string;
  fieldLabel?: string;
  variant?: "outlined" | "filled" | "standard";
  value?: string | number;
  multiline?: boolean;
  rows?: number;
  sx?: SxProps<Theme>;
  onBlur?(e: FocusEvent<HTMLInputElement>): void;
  inputProps?: InputBaseComponentProps;
  onMouseLeave?(): void;
  helperTextStyle?: CSSProperties;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  autoComplete?: string;
  autoFocus?: boolean;
  required?: boolean;
  endAdornment?: ReactNode;
}

export const TextField = (props: IProps) => {
  const {
    fieldName,
    rules,
    disabled = false,
    type = "text",
    size = "small",
    fullWidth = true,
    adornmentString,
    className,
    placeholder,
    fieldLabel,
    variant = "outlined",
    value,
    multiline = false,
    rows = 4,
    sx,
    onBlur,
    onChange,
    inputProps,
    onMouseLeave,
    helperTextStyle,
    autoComplete,
    autoFocus,
    required,
    endAdornment,
  } = props;

  const { control } = useFormContext();

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: ControllerRenderProps<FieldValues, string>
  ) => {
    field.onChange(e);
    props.onChange && props.onChange(e);
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const isShrink =
          typeof field.value !== "undefined" && field.value !== "";
        // const paddingToStart = adornmentString && !isShrink ? "15px" : "";
        // const paddingToEnd = adornmentString && !isShrink ? "20px" : "";
        return (
          <FormControl fullWidth={fullWidth} error={!!error} variant="outlined">
            <MUITextField
              {...field}
              onChange={(event) => handleChange(event, field)}
              className={className}
              placeholder={placeholder}
              label={fieldLabel}
              type={type}
              variant={variant}
              fullWidth={fullWidth}
              helperText={error?.message}
              error={!!error}
              size={size}
              multiline={multiline}
              rows={rows}
              sx={sx}
              disabled={disabled}
              {...(onBlur ? { onBlur } : {})}
              //   InputProps={{
              //     startAdornment: createAndReturnStartAdornment(
              //       adornmentString || ""
              //     ),
              //     endAdornment: createAndReturnEndAdornment(
              //       adornmentString || ""
              //     ),
              //   }}
              InputProps={{
                style: { borderRadius: "50px" },
                endAdornment: endAdornment,
              }}
              {...(onMouseLeave ? { onMouseLeave } : {})}
              FormHelperTextProps={{ style: helperTextStyle }}
              InputLabelProps={
                {
                  shrink: isShrink,
                  // style: {
                  //   paddingLeft: paddingToStart,
                  //   paddingRight: paddingToEnd,
                  // },
                }
              }
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              required={required}
              inputProps={inputProps}
            />
          </FormControl>
        );
      }}
    />
  );
};
